import React from "react";
// import Typography from "@mui/material/Typography";
import Popover from "@mui/material/Popover";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SparkImage from "../../assets/images/LineageIcons/Apache_Spark_icon.svg";
import Airflow from "../../assets/images/LineageIcons/Apache_Airflow.svg"

export default function PopoverPopupState({ open, anchorEl, handlePopoverClose }) {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handlePopoverClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      PaperProps={{
        className: "popover", // Add the class name to apply SCSS styles
      }}
    >
      <div className="header">
        <h4 className="title">
          Steps for setting up the Producer
        </h4>
        <IconButton onClick={handlePopoverClose} className="close-button">
          <CloseIcon />
        </IconButton>
      </div>
      <div className="content">
        <div className="item">
          <img src={SparkImage} alt="Spark Logo" />
          <p className="text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed tempor incididunt ut labore et dolore magna aliqua.
          </p>
        </div>
        <div className="item">
          <img src={Airflow} alt="Airflow Logo" />
          <p className="text">
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut.
          </p>
        </div>
      </div>
    </Popover>
  );
}
